import StepSection from './StepSection';

interface RouteLane {
  route: string;
  label: string;
  destination: string;
  icon: string;
  notes: string[];
  active: boolean;
}

const lanes: RouteLane[] = [
  {
    route: 'ROUTE A',
    label: 'PASS',
    destination: 'EXECUTE',
    icon: 'ri-arrow-right-line',
    notes: ['Order routed to the MT5 terminal', 'Entry · stop loss · take profit attached'],
    active: true,
  },
  {
    route: 'ROUTE B',
    label: 'REJECT',
    destination: 'NO TRADE',
    icon: 'ri-arrow-go-back-line',
    notes: ['No order is sent · setup discarded', 'Control returns to data ingestion'],
    active: false,
  },
];

function StepDecision() {
  return (
    <StepSection
      id="step-03"
      index="03"
      stage="filter"
      title="Make The Entry Decision"
      subtitle="Only a setup that passes the filter moves the process forward."
      body="The filter output is a single decision — pass or reject. A passing setup is routed toward execution; a rejected one is closed out with no position opened."
      band
    >
      <div className="rounded-lg border border-background-300 bg-background-50 overflow-hidden">
        <div className="flex items-center justify-between px-4 md:px-5 h-11 border-b border-background-200 bg-background-100">
          <span className="flex items-center gap-2 text-[11px] font-data tracking-widest text-foreground-700">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 breathe"></span>
            DECISION ROUTER
          </span>
          <span className="text-[10px] font-data tracking-widest text-foreground-400">
            OUTPUT · XAUUSD
          </span>
        </div>

        <div className="border-b border-background-200 px-4 md:px-5 py-4">
          <p className="text-[10px] font-data tracking-[0.22em] text-foreground-400">
            FILTER OUTPUT
          </p>
          <div className="mt-2 flex items-center justify-between gap-3">
            <p className="font-heading font-bold text-foreground-950 text-[16px]">
              Is the setup valid?
            </p>
            <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-background-300 bg-background-100 px-3 py-1 font-data text-[10px] tracking-[0.18em] text-foreground-500">
              <i className="ri-git-branch-line text-[13px]"></i>
              TWO ROUTES
            </span>
          </div>
        </div>

        <div className="divide-y divide-background-200">
          {lanes.map((lane) => (
            <div
              key={lane.route}
              className={`px-4 md:px-5 py-4 ${lane.active ? 'bg-primary-50/50' : ''}`}
            >
              <div className="flex items-center gap-3">
                <span
                  className={`w-2 h-2 shrink-0 rounded-full ${
                    lane.active ? 'bg-primary-500 breathe' : 'bg-background-400'
                  }`}
                ></span>
                <span
                  className={`font-data text-[11px] tracking-[0.2em] ${
                    lane.active ? 'text-primary-700' : 'text-foreground-500'
                  }`}
                >
                  {lane.label}
                </span>
                <span className="flex flex-1 items-center gap-2">
                  <span
                    className={`flex-1 h-px ${lane.active ? 'bg-primary-300' : 'bg-background-300'}`}
                  ></span>
                  <i
                    className={`${lane.icon} text-[14px] ${
                      lane.active ? 'text-primary-500' : 'text-foreground-400'
                    }`}
                  ></i>
                  <span
                    className={`flex-1 h-px ${lane.active ? 'bg-primary-300' : 'bg-background-300'}`}
                  ></span>
                </span>
                <span
                  className={`shrink-0 font-heading font-extrabold text-[15px] ${
                    lane.active ? 'text-primary-700' : 'text-foreground-600'
                  }`}
                >
                  {lane.destination}
                </span>
              </div>
              <div className="mt-2.5 flex items-start gap-3 pl-5">
                <span className="w-14 shrink-0 font-data text-[10px] tracking-widest text-foreground-400">
                  {lane.route}
                </span>
                <div className="space-y-1">
                  {lane.notes.map((note) => (
                    <p
                      key={note}
                      className={`text-[11px] leading-relaxed ${
                        lane.active ? 'text-foreground-600' : 'text-foreground-400'
                      }`}
                    >
                      {note}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200 bg-background-100 px-4 md:px-5 py-3">
          <p className="text-center text-[11px] font-data tracking-[0.16em] text-foreground-400">
            NO SETUP · NO TRADE · NO FORCED ENTRY
          </p>
        </div>
      </div>
    </StepSection>
  );
}

export default StepDecision;